import type { AllModelVersion, TaskParams } from '@/app/types';

/**
 * 判断是否为主体资产化模块
 * @param modelVersion 模型版本
 * @param taskType 任务类型
 * @returns 是否为主体资产化模块
 */
export const isReferenceAssetSupported = (modelVersion: AllModelVersion, taskType: TaskParams['type']): boolean => {
  // 参考生图都支持
  if (taskType === 'reference2image') {
    return true;
  }

  // 参考生视频，只有 1.0 和 1.5 两个老模型版本不支持
  if (taskType === 'character2video') {
    return modelVersion !== '1.0' && modelVersion !== '1.5';
  }

  // 其他任务类型都不支持
  return false;
};
